import { render } from "./AsideMenu.vue?vue&type=template&id=f5c95cb2&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import "./AsideMenu.vue?vue&type=style&index=0&id=f5c95cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5c95cb2"

export default script